import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import InsertChartOutlinedIcon from 'components/material-symbol/icons/InsertChart'
import NavigateNextOutlinedIcon from 'components/material-symbol/icons/NavigateNext'
import PeopleAltOutlinedIcon from 'components/material-symbol/icons/PeopleAlt'
import ActionButtons from './action-buttons'
import EventDetails from './index'
import EventParticipants from '../event-participants'
import EventStats from '../event-stats'
import IconBadge from './icon-badge'
import { useStyles } from './styles'
import pluralize from 'lib/pluralize'
import { useAuth } from 'lib/auth'

const CoachEventDetails = ({ event, setIsOpen, view = 'detail' }) => {
  const classes = useStyles()
  const { user } = useAuth()

  const assistantCoaches = event?.assistantCoaches?.map(coach => coach.id) || []
  const isAssistantCoach = assistantCoaches?.includes(user?.id) || false
  const canEdit = !event.isCanceled && !event.isPast() && !isAssistantCoach
  const waitlistCount = event?.waitlist?.entries.length
  const showWaitlist = waitlistCount > 0

  return (
    <>
      <EventDetails
        event={event}
        isCoachView
        view={view}
        statsContent={
          <EventStats setIsOpen={setIsOpen} event={event} embedded />
        }
        participantsContent={
          <EventParticipants setIsOpen={setIsOpen} event={event} embedded />
        }
        actionButtons={() => (
          <ActionButtons
            setIsOpen={setIsOpen}
            event={event}
            canEdit={canEdit}
          />
        )}
        participants={
          <Box
            className={classes.infoCard}
            onClick={() => setIsOpen('participants')}
          >
            <IconBadge icon={PeopleAltOutlinedIcon} variant="action" />
            <Box className={classes.infoCardContent}>
              <Typography className={classes.infoCardTitle}>
                {event.totalEnrolled}{' '}
                {pluralize(event.totalEnrolled, 'attendee')}
              </Typography>
              <Typography className={classes.infoCardSubtitle}>
                View roster
                {showWaitlist ? ` · ${waitlistCount} waitlist` : ''}
              </Typography>
            </Box>
            <NavigateNextOutlinedIcon color="action" />
          </Box>
        }
        stats={
          <Box className={classes.infoCard} onClick={() => setIsOpen('stats')}>
            <IconBadge icon={InsertChartOutlinedIcon} variant="action" />
            <Box className={classes.infoCardContent}>
              <Typography className={classes.infoCardTitle}>Stats</Typography>
              <Typography className={classes.infoCardSubtitle}>
                Registrations & revenue
              </Typography>
            </Box>
            <NavigateNextOutlinedIcon color="action" />
          </Box>
        }
      />
    </>
  )
}

export default CoachEventDetails
